import { render, staticRenderFns } from "./ThoughtCatcher.vue?vue&type=template&id=1ec7122c&scoped=true&"
import script from "./ThoughtCatcher.vue?vue&type=script&lang=js&"
export * from "./ThoughtCatcher.vue?vue&type=script&lang=js&"
import style0 from "./ThoughtCatcher.vue?vue&type=style&index=0&id=1ec7122c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7122c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VList,VSubheader,VTextField})
